export default __webpack_public_path__ + "static/montserrat-v15-latin-italic-6bf43de232ce4bdaa35a09c08a40e4d7.ttf";